// @flow

import normalizeEntity from 'normalized-redux/entity-normalizer';

const normalizedTemplateGroup = normalizeEntity<Oneflow.TemplateGroup, 'templateGroup', string[]>({
  entity: 'templateGroup',
});

export default normalizedTemplateGroup;
